import { useState, useEffect } from 'react';

interface DecodedToken {
  id: string;
  role: string;
}

const decodeJWT = (token: string): DecodedToken => {
  try {
    // Token JWT składa się z trzech części rozdzielonych kropkami: header.payload.signature
    // Nas interesuje druga część (payload)
    const base64Payload = token.split('.')[1];
    // Dekodujemy Base64 na string
    const payload = atob(base64Payload);
    // Parsujemy string JSON na obiekt
    return JSON.parse(payload);
  } catch {
    throw new Error('Invalid token');
  }
};

export const useUserRole = () => {
  const [userRole, setUserRole] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = decodeJWT(token);
        setUserRole(decoded.role);
      } catch (error) {
        console.error('Error decoding token:', error);
        setUserRole(null);
      }
    } else {
      setUserRole(null);
    }
    setIsLoading(false);
  }, []);

  return { userRole, isLoading };
};
